"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.successSchema = exports.booleanParamSchema = void 0;
const zod_1 = require("zod");
exports.booleanParamSchema = zod_1.z
    .enum(['true', 'false'])
    .transform((value) => value === 'true');
exports.successSchema = zod_1.z.object({
    success: (0, zod_1.boolean)(),
});
//# sourceMappingURL=utils.js.map